module.exports = __webpack_public_path__ + "img/calendar.666e9cd1.svg";